import _regeneratorRuntime from 'babel-runtime/regenerator';
/** @format */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// 原arms 引用alife-logger, 模块在引入时运行了iife代码，使用了document，小程序中没有window和document所以报错
// 将arms 代码改为动态引入
var isUrlLocalTest = function isUrlLocalTest(url) {
    return url.includes('192.168') || url.includes('localhost') || url.includes('127.0.0.1');
};
// const getResInfoFromUrl = (url: string) => {
//     const reg = /(?<=mPaaS\/)(.*?)\//;
//     const resInfo = url.match(reg);
//     if(!resInfo){
//         throw new Error('get resInfo error')
//     }
//     const [resName,resVersion] = decodeURIComponent(resInfo[1]).split('@')
//     return {resName,resVersion};
// }
var armsLoad = false;
export default function loadArmsAsync(appInfoModule) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isSYBIRDAPP, appInfo, resInfo, href, localTest, forbiddenUpload, isGreyMode, pid, sample, appType, imgUrl, release, tag, uid, page, environment, enableSPA, ignore, parseHash, autoSendPv, behavior, extra, div, html, oldScript, newScript;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(appInfoModule && !armsLoad)) {
                            _context.next = 51;
                            break;
                        }

                        armsLoad = true;
                        _context.prev = 2;
                        isSYBIRDAPP = window.navigator.userAgent.indexOf('App/SyBird') > -1 ? true : false;
                        _context.next = 6;
                        return appInfoModule.getAppInfo();

                    case 6:
                        _context.t0 = _context.sent.retData;

                        if (_context.t0) {
                            _context.next = 9;
                            break;
                        }

                        _context.t0 = {};

                    case 9:
                        appInfo = _context.t0;
                        _context.next = 12;
                        return appInfoModule.getResourceInfo();

                    case 12:
                        _context.t1 = _context.sent.retData;

                        if (_context.t1) {
                            _context.next = 15;
                            break;
                        }

                        _context.t1 = {};

                    case 15:
                        resInfo = _context.t1;
                        href = window.location.href;
                        localTest = isUrlLocalTest(href);
                        forbiddenUpload = !localTest;
                        // 灰度模式，数据上报ZHIJIAAPPTEST应用

                        isGreyMode = appInfo && appInfo.grayMode;
                        // 项目唯一ID，由ARMS在创建站点时自动生成。

                        pid = isGreyMode ? isSYBIRDAPP ? 'hp8r7tbybs@577457c4bff264a' : 'hp8r7tbybs@d5c347b296e2ece' : isSYBIRDAPP ? 'hp8r7tbybs@6137039dfa93d1f' : 'hp8r7tbybs@272051411c7e0e5';
                        sample = isGreyMode ? 1 : 100; // 日志采样配置，值为1、10或100。性能和成功API日志按照1/sample的比例采样。

                        appType = 'web'; // app类型

                        imgUrl = 'https://arms-retcode.aliyuncs.com/r.png?'; // 设定日志上传地址

                        release = appInfo.appVersion || ''; // 应用版本号。

                        tag = resInfo.resVersion || ''; // 资源包版本号

                        uid = appInfo.clientId || ''; // 用户ID，用于标识访问用户，可手动配置，用于根据用户ID检索。

                        page = resInfo.resName || ''; // 资源包名称。

                        environment = isGreyMode ? 'gray' : 'prod'; // 环境字段，取值为：prod、gray、pre、daily和local

                        enableSPA = true; // 监听页面的hashchange事件并重新上报PV，适用于单页面应用场景。
                        // 忽略指定URL/API/JS错误。

                        ignore = '{ignoreUrls: [\'192.168\', \'localhost\', \'127.0.0.1\']}';
                        // 在enableSPA设为true的前提下，页面触发hashchange事件时，parseHash参数用于将URL Hash解析为Page字段。

                        parseHash = 'function (hash) {return \'' + resInfo.resName + '\' + hash}';
                        autoSendPv = isGreyMode ? forbiddenUpload : false; // 是否自动上报pv

                        behavior = autoSendPv; // 是否为了便于排查错误而记录报错的用户行为。
                        // 禁用AJAX请求监听。

                        extra = isGreyMode ? ',disabled: ' + !forbiddenUpload : ',disableHook: true';
                        div = document.createElement('div');

                        div.style.display = 'none';
                        document.body.appendChild(div);
                        html = '<script>\n        !(function(c,b,d,a){\n            c[a]||(c[a]={});\n            c[a].config={\n                pid:\'' + pid + '\',\n                appType:\'' + appType + '\',\n                imgUrl:\'' + imgUrl + '\',\n                release:\'' + release + '\',\n                tag:\'' + tag + '\',\n                uid:\'' + uid + '\',\n                page:\'' + page + '\',\n                sample:' + sample + ',\n                environment:\'' + environment + '\',\n                ignore:' + ignore + ',\n                parseHash:' + parseHash + ',\n                autoSendPv:' + autoSendPv + ',\n                enableSPA: ' + enableSPA + ',\n                behavior:' + behavior + extra + ',\n                sendResource: true,\n                enableLinkTrace: true,\n                useFmp: true,\n                }\n            with(b)\n            with(body)\n            with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)\n        })(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");\n        </script>';

                        div.innerHTML = html;
                        oldScript = div.getElementsByTagName('script')[0];

                        div.removeChild(oldScript);
                        newScript = document.createElement('script');

                        newScript.type = 'text/javascript';
                        newScript.innerHTML = oldScript.innerHTML;
                        div.appendChild(newScript);
                        // sync 方式
                        // `<script>
                        // window.__bl = {
                        //     pid: ${pid},
                        //     appType: ${appType},
                        //     imgUrl: ${imgUrl},
                        //     release: ${release},
                        //     tag: ${tag},
                        //     uid: ${uid},
                        //     page: ${page},
                        //     sample: ${sample},
                        //     environment: ${environment},
                        //     enableSPA: ${enableSPA},
                        //     ignore: ${ignore},
                        //     parseHash: ${parseHash},
                        //     autoSendPv: ${autoSendPv},
                        //     behavior: ${behavior}${extra},
                        // };
                        // </script>`;
                        // `<script type="text/javascript" src="https://retcode.alicdn.com.retcode/bl.js"
                        // crossorigin></script>`;
                        _context.next = 51;
                        break;

                    case 48:
                        _context.prev = 48;
                        _context.t2 = _context['catch'](2);

                        window.console.log('arms went wrong..............', _context.t2);

                    case 51:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[2, 48]]);
    }));
}